import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-6 col-lg-8" }
const _hoisted_3 = { class: "col-12 col-md-6 col-lg-4" }
const _hoisted_4 = { class: "card mb-4" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = { class: "card-title mb-0" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("ul", { class: "list-group list-group-flush" }, [
  /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, "Bancontact"),
  /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, "Google Pay"),
  /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, "iDeal"),
  /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, "Mastercard"),
  /*#__PURE__*/_createElementVNode("li", { class: "list-group-item" }, "Visa")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTitle = _resolveComponent("BaseTitle")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_BaseTitle, {
        title: "Worldline",
        mb: 4,
        "back-route": {name: 'pharma-pay'}
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('settingsDigitalPharmaReference')), 1),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('supportedPaymentMethods')), 1)
            ]),
            _hoisted_7
          ])
        ])
      ])
    ]),
    _: 1
  }))
}